export default __webpack_public_path__ + "static/media/27_gallery.5502c345.jpg";